<template>
  <div>
    <v-list-item>
      <v-list-item-avatar>
        <v-icon>{{ control.icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        {{ control.name }}
      </v-list-item-content>
    </v-list-item>
    <v-divider v-if="control.divider"></v-divider>
  </div>
</template>

<script>
export default {
  name: 'Control',
  props: {
    control: {
      required: true,
      type: Object
    }
  }
}
</script>
